import React from "react";
import svg20 from "../../../assets/svg/svg20.svg";
import svg21 from "../../../assets/svg/svg21.svg";
import svg22 from "../../../assets/svg/svg22.svg";
import svg23 from "../../../assets/svg/svg23.svg";
import svg24 from "../../../assets/svg/svg24.svg";
import svg25 from "../../../assets/svg/svg25.svg";

const items = [
  {
    title: "Crops",
    count: 4,
    svg: "svg20",
  },
  {
    title: "Impact",
    count: 325,
    svg: "svg21",
  },
  {
    title: "Reclaimed Area",
    count: "326 Acres",
    svg: "svg22",
  },
  {
    title: "Irrigated Area",
    count: "434 Acres",
    svg: "svg23",
  },
];
function IwuaDashCard() {
  const svgMap = {
    svg20,
    svg21,
    svg22,
    svg23,
    svg24,
    svg25,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  return (
    <div className="flex flex-shrink flex-wrap gap-[1.75rem]">
      {processedData &&
        processedData?.map((item) => (
          <>
            {" "}
            <div className="rounded-[.75rem] border border-[#D6E1F5] bg-[#F7F7F7] h-[6.25rem] lg:w-[17.75rem] w-full p-[.5rem]">
              <div className="flex items-center justify-between">
                <div className="scheme-card-title">{item?.title}</div>
                <img src={item?.svg} alt={item?.svg} />
              </div>
              <div
                className={`scheme-card-content mt-[1.62rem] ${
                  item?.count == 0 && "!text-[#DD2222]"
                }`}
              >
                {item?.count}
              </div>
            </div>
          </>
        ))}
    </div>
  );
}

export default IwuaDashCard;
